var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 40,
    viewBox: "0 0 97 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Auto"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line",
    x1: 20.5,
    y1: 19.5,
    x2: 32.5,
    y2: 19.5,
    stroke: "#AED2FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Src"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 12,
    width: 24,
    height: 16,
    rx: 2,
    fill: "#AED2FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-physics",
    clipPath: "url(#clip0_23674_351091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M59.063 9.43729C56.689 7.06329 53.144 7.64229 48.5 11.1373C43.857 7.64229 40.313 7.06229 37.937 9.43729C35.561 11.8123 36.142 15.3563 39.637 20.0003C36.142 24.6433 35.562 28.1883 37.937 30.5633C38.3823 31.025 38.9174 31.3907 39.5093 31.6378C40.1013 31.885 40.7376 32.0083 41.379 32.0003C43.35 32.0003 45.73 30.9483 48.5 28.8643C51.269 30.9483 53.649 32.0003 55.621 32.0003C56.2624 32.0083 56.8987 31.885 57.4906 31.6378C58.0826 31.3907 58.6177 31.025 59.063 30.5633C61.438 28.1883 60.863 24.6443 57.363 20.0003C60.858 15.3563 61.438 11.8123 59.063 9.43729V9.43729ZM55.585 10.0283C55.9671 10.0168 56.3476 10.0835 56.7031 10.2243C57.0585 10.3652 57.3814 10.5772 57.652 10.8473C59.398 12.5943 58.108 15.5603 56.064 18.3863C55.226 17.3983 54.282 16.3713 53.206 15.2943C52.13 14.2173 51.1 13.2733 50.112 12.4343C52.01 11.0613 53.972 10.0283 55.585 10.0283V10.0283ZM54.811 20.0003C53.8 21.2203 52.729 22.3613 51.795 23.3003C50.861 24.2393 49.72 25.3003 48.5 26.3113C47.28 25.3003 46.139 24.2293 45.205 23.3003C44.271 22.3713 43.2 21.2203 42.189 20.0003C43.2 18.7803 44.271 17.6383 45.205 16.7053C46.139 15.7723 47.28 14.7003 48.5 13.6883C49.72 14.6983 50.861 15.7713 51.8 16.7053C52.739 17.6393 53.8 18.7803 54.811 20.0003ZM39.348 10.8483C39.6183 10.5777 39.9411 10.3653 40.2966 10.2243C40.6521 10.0833 41.0327 10.0166 41.415 10.0283C43.028 10.0283 44.99 11.0613 46.888 12.4343C45.9 13.2733 44.872 14.2173 43.794 15.2943C42.716 16.3713 41.774 17.3943 40.935 18.3863C38.892 15.5603 37.6 12.5943 39.348 10.8483V10.8483ZM39.348 29.1483C37.602 27.4023 38.892 24.4353 40.935 21.6103C41.774 22.5983 42.718 23.6253 43.794 24.7023C44.87 25.7793 45.894 26.7253 46.883 27.5633C44.058 29.6093 41.092 30.9003 39.348 29.1523V29.1483ZM57.648 29.1483C55.903 30.8923 52.938 29.6053 50.113 27.5633C51.099 26.7253 52.127 25.7763 53.202 24.7023C54.277 23.6283 55.222 22.6023 56.06 21.6103C58.108 24.4403 59.4 27.4063 57.652 29.1523L57.648 29.1483Z",
    fill: "#265EDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M48.4999 22.0002C49.6044 22.0002 50.4999 21.1048 50.4999 20.0002C50.4999 18.8957 49.6044 18.0002 48.4999 18.0002C47.3953 18.0002 46.4999 18.8957 46.4999 20.0002C46.4999 21.1048 47.3953 22.0002 48.4999 22.0002Z",
    fill: "#265EDB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Dest"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 12,
    width: 24,
    height: 16,
    rx: 2,
    fill: "#AED2FF"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    x1: 64.5,
    y1: 19.5,
    x2: 76.5,
    y2: 19.5,
    stroke: "#AED2FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23674_351091"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(36.5 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuto);
export default __webpack_public_path__ + "static/media/auto.87f562a288a3871bb3d47597c7256a8d.svg";
export { ForwardRef as ReactComponent };